import { NavigationRoute } from '@nextforce/api'
import { useRoutingContext } from 'app/routing_context'
import { CrewListScreenProps, HomeStackParamList } from 'home/stack/types'
import React, { useCallback, useLayoutEffect } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { useRecentStoresContext } from 'stores/context'
import { showStoreHeaderDropdown } from 'stores/dropdown'
import { useStores } from 'stores/queries/list'
import { useCrewList } from './queries/list'
import CrewListView from './view'

export function CrewListScreen({ navigation }: CrewListScreenProps) {
  const { activeStoreId, recentStores, setActiveStoreId } =
    useRecentStoresContext()
  const { data: stores } = useStores(data => data.stores)
  const { handleNavigation } = useRoutingContext()
  const query = useCrewList(activeStoreId)

  useLayoutEffect(() => {
    showStoreHeaderDropdown(navigation, handleNavigation, {
      activeStoreId,
      recentStores,
      stores,
      setActiveStoreId,
    })
  }, [
    activeStoreId,
    handleNavigation,
    navigation,
    recentStores,
    setActiveStoreId,
    stores,
  ])

  const onPress = useCallback(
    (route: NavigationRoute | undefined) => {
      if (!route) {
        return
      }
      handleNavigation({
        routeName: route.name as keyof HomeStackParamList,
        routeParams: route.params && { ...route.params },
      })
    },
    [handleNavigation]
  )

  return (
    <StatusBoundary isLoading={query.isLoading} error={query.error}>
      <CrewListView groups={query.data?.groups} onPress={onPress} />
    </StatusBoundary>
  )
}
